import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "common/locales";
import { GRASS_TYPE } from "model";

interface GrassTypeDropdownProps {
  currentGrassType?: string;
  disabled: boolean;
  onChange: (value?: GRASS_TYPE) => void;
  grassTypeInputError: boolean;
  label: string;
}

export default function GrassTypeDropdown({
  disabled,
  onChange,
  currentGrassType,
  grassTypeInputError,
  label,
}: GrassTypeDropdownProps) {
  const { t } = useTranslation();

  return (
    <TextField
      select
      fullWidth
      disabled={disabled}
      value={currentGrassType ?? ""}
      onChange={(e) => onChange(e.target.value as GRASS_TYPE | undefined)}
      error={grassTypeInputError}
      label={t(label)}
      InputLabelProps={{ shrink: true }}
      SelectProps={{
        displayEmpty: true,
      }}
    >
      <MenuItem value="" disabled>
        <em>{t("reseedEvent.grassType.placeholder")}</em>
      </MenuItem>
      {Object.entries(GRASS_TYPE).map(([key, value]) => (
        <MenuItem value={value} key={key}>
          {t(`fieldinput.grassType.option.${value}`)}
        </MenuItem>
      ))}
    </TextField>
  );
}
